import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../../service/order.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettings } from '../../../shared/AppSettings';

@Component({
  selector: 'app-supplier-invoice-send',
  templateUrl: './supplier-invoice-send.component.html',
  styleUrls: ['./supplier-invoice-send.component.css']
})
export class SupplierInvoiceSendComponent implements OnInit {

  readonly rootUrl = AppSettings.webApiURL;
  
  orderIdLink: any = null;
  orderId?: number = null;

  orderDetails: any;
  currentPhase: number = 0;
  currentPhaseDone: boolean = false;
  progressValue: any;
  attachments: any = [];
  invoiceFileNameAttached: any;

  invoiceTypes: any[];
  invoiceTypeSelected: any;
  invoiceOrderLines: any[];
  invoiceOrderLinesSelected: any[];
  invoiceDate: any;
  invoiceNumber: any;
  invoiceQuantity: any;
  invoiceUnitePrice: any;
  invoiceTotal: any;
  invoiceTotalWithTax: any;

  validationMessage: any;
  validationMessages: any[];
  msgs: Message[] = [];

  showInvoiceNumberChekers: boolean = false;
  invoiceNumberIsExists: boolean = false;


  constructor(private orderService: OrderService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getOrderDetails();

    
  }

  orderDetailsCreated(event) {
    this.orderDetails = event;
  }

  getOrderDetails()
  {
    //let orderId = this.route.snapshot.paramMap.get('order');
    //if (orderId == 'none') {orderId = null;}
    //if (orderId == null || orderId == '') {
      let orderId = this.route.snapshot.queryParamMap.get('o');
    //}

    this.orderIdLink = orderId;
    this.orderId = null;
     
    // let orderFilterByOrderIdEncoded = {
    //   OrderIdLink: orderId,    
    //   OrderId: null
    // };
    // this.orderService.getSupplierOrderDetails(orderFilterByOrderIdEncoded).subscribe((result: any) => {
    //   this.orderDetails = result;
    //   this.currentPhase = 1;
    //   this.Phase1Init();


    // },
    //   (err: HttpErrorResponse) => {
    //     let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בקבלת נתונים ';
    //     this.showMessage('error', '', errMessage);
    //   });

    this.currentPhase = 1;
    this.showInvoiceNumberChekers = false;
    this.Phase1Init();
  }


  // Phase 1 ------------------------------------------------------------

  Phase1Init() {
    this.currentPhaseDone = false;
  }

  private onBeforeSend(event) {
    this.progressValue = '';
    let userToken = localStorage.getItem('userToken');
    // event.xhr.open("POST", 'http://localhost:34567/api/ComposeMessageApi/upload', true);
    event.xhr.setRequestHeader("Authorization", "Bearer " + userToken);
    event.xhr.withCredentials = true;
  }

  onProgress(event) {
    if (event.originalEvent.loaded !== 0) {
      this.progressValue = Math.round((event.originalEvent.loaded / event.originalEvent.total) * 100).toString() + '%';
    }
  }

  onError(event: any) {
    this.progressValue = '';
    this.attachments = [];
    let er = JSON.parse(event.xhr.responseText);
    if (er) {
        this.showMessage('error', '', er.ExceptionMessage);
    } else {
        this.showMessage('error', '', 'תקלה בהעלאת קובץ');
    }
  }

  onUpload(event) {
    this.progressValue = '';
    //this.refreshAttachments();
    let f = event.xhr.responseText;
    if (!f || f == '') {
      this.showMessage('error', '', 'תקלה בהעלאת קובץ');
      return;
    }
    this.attachments = [];
    this.attachments.push({Name: event.files[0].name, Size: event.files[0].size});

    this.invoiceFileNameAttached = f;
    this.currentPhaseDone = true;
  }

  refreshAttachments() {
    // this.orderService.getAttachments().subscribe(result => {
    //   this.attachments = result;
      
    // }, 
    // (err: HttpErrorResponse) => {
    //   this.showMessage('error', '', 'תקלה באיחזור קבצים');
    // });
  }

  removeAttachment(attachment) {
    // this.orderService.removeAttachment(attachment.Name).subscribe(result => {
    //   this.refreshAttachments();
      
    // }, 
    // (err: HttpErrorResponse) => {
    //   this.showMessage('error', '', 'קלה במחיקת קובץ');
    // });

    this.attachments = [];

  }

  Phase1Finish() {
      this.Phase2Init();
  }

  // Phase 1 End --------------------------------------------------------




  // Phase 2 ------------------------------------------------------------

  Phase2Init() {
    this.invoiceTypes = [{value: '1', label: 'חשבונית'},{value: '2', label: 'דוח שרות'},{value: '3', label: 'תעודת משלוח'}];
    this.invoiceOrderLines = this.orderDetails.OrderLines;

    this.showInvoiceNumberChekers = false;
    this.currentPhaseDone = false;
    this.currentPhase = 2;
  }

  Phase2Finish() {
    this.currentPhaseDone = false;
    this.validatePhase2();
    if (this.currentPhaseDone) {
      // TODO: valid, continue to save
      //let orderIdEncoded = this.route.snapshot.paramMap.get('order');
      //if (orderIdEncoded == 'none') { orderIdEncoded = null; }
      //if (orderIdEncoded == null || orderIdEncoded == '') {
        let orderIdEncoded = this.route.snapshot.queryParamMap.get('o');
      //}
      let invoice = {
        InvoiceId: null,
        OrderId: this.orderDetails.OrderId,
        OrderEncoded: orderIdEncoded,
        InvoiceTypeId: this.invoiceTypeSelected,
        InvoiceDate: this.invoiceDate ? new Date(Date.UTC(this.invoiceDate.getFullYear(), this.invoiceDate.getMonth(), this.invoiceDate.getDate())) : null,
        InvoiceNumber: this.invoiceNumber,
        Quantity: this.invoiceQuantity,
        UnitePrice: this.invoiceUnitePrice,
        Total: this.invoiceTotal,
        TotalWithTax: this.invoiceTotalWithTax,
        FileNameAttached: this.invoiceFileNameAttached,
        OrderLines: this.invoiceOrderLinesSelected
      };


      this.orderService.SupplierInvoiceSend(invoice).subscribe((result: any) => {
        this.currentPhaseDone = true;
        this.currentPhase = 3;
      },
        (err: HttpErrorResponse) => {
          let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בעדכון נתונים ';
          this.showMessage('error', '', errMessage);
        });

    }
  }

  validatePhase2() {
    this.validationMessage = '';
    this.validationMessages = [];

    // required field validation
    if (this.invoiceTypeSelected == '1' ) {
      // חשבונית
      if (!this.invoiceOrderLinesSelected || this.invoiceOrderLinesSelected.length == 0) {
        this.validationMessages.push('נא לבחור שורות בהזמנה עבורן יוגש המסמך');
      }
      if (!this.invoiceDate) {
        this.validationMessages.push('שדה תאריך מסמך הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (!this.invoiceNumber) {
        this.validationMessages.push('שדה מסמפר מסמך הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (!this.invoiceQuantity) {
        this.validationMessages.push('שדה כמות הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (!this.invoiceUnitePrice) {
        this.validationMessages.push('שדה מחיר ליחידה הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (!this.invoiceTotal) {
        this.validationMessages.push('שדה סה"כ הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (!this.invoiceTotalWithTax) {
        this.validationMessages.push('שדה סה"כ כולל מע"מ הינו שדה חובה עבור מסמך מסוג שנבחר');
      }
      if (this.invoiceNumberIsExists) {
        this.validationMessages.push('מספר מסמך שהוזן כבר קיים לספק');
      }

    } else if (this.invoiceTypeSelected == '2' ) {
      // דוח שירות
      if (!this.invoiceOrderLinesSelected || this.invoiceOrderLinesSelected.length == 0) {
        this.validationMessages.push('נא לבחור שורות בהזמנה עבורן יוגש המסמך');
      }
    } else if (this.invoiceTypeSelected == '3' ) {
      // תעודת משלוח
      if (!this.invoiceOrderLinesSelected || this.invoiceOrderLinesSelected.length == 0) {
        this.validationMessages.push('נא לבחור שורות בהזמנה עבורן יוגש המסמך');
      }
    } else {
      this.validationMessages.push('שדה סוג מסמך הינו שדה חובה');
    }

    // data types validaition
    if (this.invoiceQuantity && isNaN(this.invoiceQuantity)) {
      this.validationMessages.push('שדה כמות חייב להיות מספרי');
    }
    if (this.invoiceUnitePrice && isNaN(this.invoiceUnitePrice)) {
      this.validationMessages.push('שדה מחיר ליחידה חייב להיות מספרי');
    }
    if (this.invoiceTotal && isNaN(this.invoiceTotal)) {
      this.validationMessages.push('שדה סה"כ חייב להיות מספרי');
    }
    if (this.invoiceTotalWithTax && isNaN(this.invoiceTotalWithTax)) {
      this.validationMessages.push('שדה סה"כ כולל מע"מ חייב להיות מספרי');
    }


    if (this.validationMessages.length > 0) {
        this.currentPhaseDone = false;
        this.validationMessage = this.validationMessages[0];
    } else {
      this.currentPhaseDone = true;
    }

  }

  onFocusInvoiceNumber() {
    this.showInvoiceNumberChekers = false;
  }

  onChangeInvoiceNumber() {
    if (this.invoiceNumber != null && this.invoiceNumber != '') {
      this.orderService.isInvoiceNumberForSupplierExist(this.invoiceNumber).subscribe((result: any) => {
        this.invoiceNumberIsExists = result;
        this.showInvoiceNumberChekers = true;
      },
        (err: HttpErrorResponse) => {
          let errMessage = (err.error && err.error.ExceptionMessage) ? err.error.ExceptionMessage : 'תקלה בבדיקת מספר מסמך ';
          this.showMessage('error', '', errMessage);
      });

    }
  }


  // Phase 2 End ---------------------------------------------------------


  // Phase 3 -------------------------------------------------------------

  StartOver() {
    //let orderIdEncoded = this.route.snapshot.paramMap.get('order');
    //if (orderIdEncoded == 'none') { orderIdEncoded = null; }
    //if (orderIdEncoded == null || orderIdEncoded == '') {
      let orderIdEncoded = this.route.snapshot.queryParamMap.get('o');
    //}
      window.location.href = '/supplier-invoice-send/?o=' + encodeURIComponent(orderIdEncoded);
  }

  Phase3Finish() {
    window.location.href = '/supplier-order-list/';
  }


  // Phase 3 End ----------------------------------------------------------




  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/invoice/supplier-invoice/supplier-invoice-send/supplier-invoice-send.component.ts